import { render, staticRenderFns } from "./DetalleSolicitud.vue?vue&type=template&id=71a339f0&scoped=true"
import script from "./DetalleSolicitud.vue?vue&type=script&lang=js"
export * from "./DetalleSolicitud.vue?vue&type=script&lang=js"
import style0 from "./DetalleSolicitud.vue?vue&type=style&index=0&id=71a339f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a339f0",
  null
  
)

export default component.exports